/** 签约记录中的快钱支付渠道标识。 */
export function isKqAgreement(agreement) {
  return agreement?.tradeType === "KqPay";
}

/** 接口和快钱业务均成功后，才根据交易卡列表判断签约状态。 */
export function parseKqAgreementStatus(response) {
  if (response?.code !== 200) {
    throw new Error(
      response?.content || response?.message || response?.msg || "快钱详情查询失败",
    );
  }
  const detail = response.data;
  if (detail?.bizResponseCode !== "0000") {
    throw new Error(detail?.bizResponseMessage || "快钱签约状态查询失败");
  }
  const cards = detail.pciInfos ?? [];
  if (
    !Array.isArray(cards) ||
    cards.some((card) => !card || typeof card !== "object" || Array.isArray(card))
  ) {
    throw new Error("快钱交易卡信息格式异常");
  }
  return { ...detail, pciInfos: cards };
}
